(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mobile-slider-moon-corn"] && !Shopify.designMode) return;
  try {
    
(function() {
  const initVanilla = () => {
    let currentSlide = 0;

    const nextSlide = () => {
      currentSlide = (currentSlide + 1) % 4;
      updateSlider();
    };

    const prevSlide = () => {
      currentSlide = (currentSlide - 1 + 3) % 3;
      updateSlider();
    };

    const updateSlider = () => {
      const slide = document.querySelector(".custom-product");
      const carousel = document.querySelector(".carousel");
      if (!slide || !carousel) return;

      const slideWidth = slide.getBoundingClientRect().width;
      const newPosition = -currentSlide * slideWidth;
      carousel.style.transform = `translateX(${newPosition}px)`;
    };

    document.querySelectorAll(".custom-control").forEach((control) => {
      control.addEventListener("click", () => {
        if (control.classList.contains("next")) {
          nextSlide();
        } else {
          prevSlide();
        }
      });
    });
  };

  const initWithJquery = ($) => {
    $(document).ready(function() {
      let currentSlide = 0;

      const nextSlide = () => {
        currentSlide = (currentSlide + 1) % 4;
        updateSlider();
      };

      const prevSlide = () => {
        currentSlide = (currentSlide - 1 + 3) % 3;
        updateSlider();
      };

      const updateSlider = () => {
        const slideWidth = $(".custom-product").outerWidth();
        const newPosition = -currentSlide * slideWidth;
        $(".carousel").css("transform", `translateX(${newPosition}px)`);
      };

      $(".custom-control").on("click", function() {
        if ($(this).hasClass("next")) {
          nextSlide();
        } else {
          prevSlide();
        }
      });
    });
  };

  if (window.jQuery && typeof window.jQuery === "function") {
    initWithJquery(window.jQuery);
  } else if (document.readyState !== "loading") {
    initVanilla();
  } else {
    document.addEventListener("DOMContentLoaded", initVanilla);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-slider-moon-hyd"] && !Shopify.designMode) return;
  try {
    


  
$(document).ready(function() {
      let currentSlide = 0;

      const nextSlide = () => {
        currentSlide = (currentSlide + 1) % 4;
        updateSlider();
      };

      const prevSlide = () => {
        currentSlide = (currentSlide - 1 + 4) % 4;
        updateSlider();
      };

      const updateSlider = () => {
        const slideWidth = $(".custom-drink").outerWidth();
        const newPosition = -currentSlide * slideWidth;
        $(".slider").css("transform", `translateX(${newPosition}px)`);
      };

      $(".custom-control").on("click", function() {
        if ($(this).hasClass("next")) {
          nextSlide();
        } else {
          prevSlide();
        }
      });
    });

  } catch(e) { console.error(e); }
})();
})();
